import React, { Component } from "react";

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = { activeSection: "hero" };
    this.handleScroll = this.handleScroll.bind(this);
  }

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll, { passive: true });
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll() {
    const sections = ["hero", "about", "experience", "projects", "skills", "certs"];
    let current = "hero";
    sections.forEach((id) => {
      const el = document.getElementById(id);
      if (el && window.scrollY >= el.offsetTop - 150) current = id;
    });
    if (current !== this.state.activeSection) {
      this.setState({ activeSection: current });
    }
  }

  render() {
    const { onLangChange, currentLang, resumeBasicInfo } = this.props;
    const { activeSection } = this.state;
    const navLabels = resumeBasicInfo?.ui?.nav || ["About", "Experience", "Projects", "Skills", "Certs"];
    const navItems = [
      { href: "#about",      label: navLabels[0] },
      { href: "#experience", label: navLabels[1] },
      { href: "#projects",   label: navLabels[2] },
      { href: "#skills",     label: navLabels[3] },
      { href: "#certs",      label: navLabels[4] },
    ];

    return (
      <nav id="nav">
        <a href="#hero" className="nav-logo">
          JF<em>.</em>
        </a>
        <ul className="nav-links">
          {navItems.map(({ href, label }) => (
            <li key={href}>
              <a
                href={href}
                className={activeSection === href.slice(1) ? "active" : ""}
              >
                {label}
              </a>
            </li>
          ))}
          <li>
            <div className="lang-toggle">
              <button
                className={`lang-btn${currentLang === "en" ? " active" : ""}`}
                onClick={() => onLangChange("en")}
              >
                EN
              </button>
              <button
                className={`lang-btn${currentLang === "es" ? " active" : ""}`}
                onClick={() => onLangChange("es")}
              >
                ES
              </button>
            </div>
          </li>
        </ul>
      </nav>
    );
  }
}

export default Header;
